manageSigners.vue

<template>
    <div class="dialog-body d-flex flex-column h-100">
        <div class="flex flex-grow-1 d-flex flex-column dialog-content overflow-auto">
            <v-toolbar>
                <div class="d-flex align-items-center pl-3">
                   <v-card-title class="text-h5 blue lighten-2">
                        {{ $t("res_Title_Signers")}}
                    </v-card-title>
                </div>
                <v-spacer></v-spacer>
                 <v-btn class="close-btn light-btn tracker-close" icon dark @click="closeSignersDialog">
                        <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <!-- <div class="border-top d-flex flex-wrap flex-fill">
                <div class="row px-5 py-5">
                    <div class="col-md-4">
                        <label>{{ $t("res_Label_Signer")}}</label>
                        <MultiSelect class="light-bg" v-model="user" label="name" track-by="id" open-direction="bottom"
                            placeholder="Select user" :options="users" :searchable="true" :loading="loading"
                            :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
                            :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                            @search-change="asyncFindUser" @close="users = []">
                            <template slot="option" slot-scope="props">
                                <div style="height: 50px; width: 100%; display: flex">
                                    <div class="" style="">
                                        <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                                    </div>
                                    <div class="ad__box" v-if="props.option.isUser">
                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                    </div>
                                    <div class="ad__box" v-else>
                                        <p class="ad__text__bold">{{ props.option.name }}</p>
                                        <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                    </div>
                                </div>
                            </template>
                            <template slot="noOptions" slot-scope="props">
                                {{$t("res_Msgs_EmptySearch")}}
                            </template>
                        </MultiSelect>
                    </div>
                </div>
            </div>

            <div class="px-2" style="text-align: right">
                <v-btn color="primary"                          dense class="mx-2" @click="closeSignersDialog">{{ $t("res_ButtonText_Cancel")}}</v-btn>
                <v-btn color="primary" :disabled="disableFields" dense class="mx-2" @click="updateSigner">{{ $t("res_ButtonText_Update")}}</v-btn>
            </div> -->
            
            <div class="px-5" >                    
                <v-data-table class="position-relative pt-5 hide_footer white" disable-sort :headers="signersHeader"
                    :items="allSignersData" :loading="loading" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                    :footer-props="{ 'items-per-page-text': 'Items per page' }" caption="" 
                     hide-default-footer>
                    <template v-slot:item="row">
                        <tr>
                            <td style="display: none">{{ row.item.id }}</td>
                            <td>{{ row.item.userName }}</td>
                            <td>{{ row.item.structureName }}</td>
                            <td>{{ row.item.signatureOrder }}</td>
                            <td>{{ dateFormat(row.item.signatureDate, 'dd/MM/yyyy')  == null ? "signature date got reset" : dateFormat(row.item.signatureDate, 'dd/MM/yyyy')}}</td>
                            <!-- <td>
                                <div class="d-flex">
                                    <v-btn class="white--text" elevation="2" color="#00ae8d" 
                                        @click="editCurrentSignature(row.item.userId, row.item.userName, row.item.signatureOrder)">
                                        {{ $t("res_ButtonText_Edit")}}</v-btn>
                                    <v-btn class="white--text ml-3"
                                        elevation="2" color="#ff902b" :disabled="row.item.signatureImage  == null" 
                                        @click="resetCurrentSignature(row.item.documentId, row.item.userId, row.item.signatureOrder)">
                                        {{ $t("res_ButtonText_Reset")}}
                                    </v-btn>
                                </div>
                            </td> -->
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { defaultGet, defaultPost } from '@/assets/js/common.js'
    import constants from '@/assets/js/constants.js'
    import axios from 'axios'
    import MultiSelect  from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    
	export default {
		name: 'ManageTransfers',
        components: { MultiSelect },
        props: {
            refreshToken: { type: String, default: '' },
        },
		data() {
            return {
                loading: false,
                disableFields: true,
                allSignersData: [],
                signersHeader: [
                    { text: 'Id',                       value: 'id',                    align: ' d-none'},
                    { text: 'UserName',                 value: 'userName',              width: '25%' },
                    { text: 'StructureName',            value: 'structureName',         width: '25%' },
                    { text: 'Signature Order',          value: 'signatureOrder',        width: '10%' },
                    { text: 'Signature Date',           value: 'signatureDate',         width: '20%' }
                    // { text: 'Actions',                  value: '',                      width: '20%' }
                ],
                oldUser: {},
                user: {},
                users: [],
                sortOrderId: 0,
                dateFormat: window.dateFormatForExternlUse
            };
        },
        props: 
        {
            documentId:      { type: [String, Number],  default: 0     },
            dialogModelShow: { type: Boolean, default: false }, 
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    { 
                        this.getAllSigners();
                    }
                }
            },
        },
        mounted: function () 
        {
            this.getAllSigners();
            this.asyncFindUser("");
        },
        methods: 
        {
            getAllSigners() 
            {
                //;
                this.allSignersData = [];
                 axios.get(constants.baseApiUrl + 'Template/GetTemplateSigners?documentId='+
                    this.documentId, { headers: constants.headers })
                        .then(res => 
                        {
                            if(res.data != null)
                            {
                                this.allSignersData = res.data;
                            }
                        })
                        .catch(err => console.warn(err))
            },
            closeSignersDialog()
            {
                this.user = {}
                this.$emit('closeSignersDialog', 0)
            },
            updateSigner()
            {
                if(this.oldUser.id != this.user.id.toString().split('-')[0] && this.oldUser.id != this.user.id.toString().split('-')[1])
                {
                    window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_UpdateUserofSignaruresConfirmation"),
                    () => 
                    { 
                        var updatedUserId = this.user.id.toString().split('-')[0];
                        var updateTransfer = {
                            DocumentId: this.documentId,
                            UserId: this.oldUser.id,
                            UpdatedUserId: updatedUserId,
                            SignatureOrderId: this.sortOrderId
                        }

                        axios.post(constants.baseApiUrl + 'Template/UpdateTemplateSignatures', updateTransfer, { headers: constants.headers })
                            .then((res) => 
                            {
                                if (res.data != null)
                                {
                                this.getAllSigners();
                                }
                            }).catch(err => console.warn(err))

                    }, () =>{ })
                }
                else
                {
                    window.showAlert('res_Msgs_SignatureUserViolation', 'warning')
                }
            },
            asyncFindUser(query) {
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => 
                    {
                        if(res.data != null)
                        {
                            this.users = res.data
                        }
                    })
                    .catch(err => console.warn(err))
            },
            editCurrentSignature(userId, userName, signatureOrder)
            {
                this.disableFields = false;
                this.oldUser = {id: userId, name: userName};
                this.user = {id: userId, name: userName};
                this.sortOrderId = signatureOrder;
            },
            resetCurrentSignature(documentId, userId, signatureOrder)
            {
                window.showInformation('res_Msgs_Confirmation', window.translate("res_Msgs_ResetSignaturesConfirmation"),
                    () => 
                    { 
                       var requestBody = {
                            documentId: documentId,
                            userId: userId,
                            SignatureOrderId: signatureOrder
                       };
                       axios.post(constants.baseApiUrl + 'Template/ResetTemplateSignatures', requestBody, { headers: constants.headers })
                        .then(res => 
                        {
                            if (res.data != null && res.data > 0)
                            {
                                window.showAlert('res_Msgs_SignaturesReset', 'success')
                                this.getAllSigners();
                            }
                        })
                        .catch(err => console.warn(err))
                    }, () =>{ })
            },
            CapitalizeFirstLetter(string) 
			{
				return utils.CapitalizeFirstLetter(string)
			},
            GetMultiSelectSubHeaderDisplay(options)
            {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            }
        }
	}
</script>

<style scoped>
    .template_filter_container { justify-content: space-between; align-items: flex-end; }
    .template_card:hover,  .template_card:focus  {background-color: #f1f8ff !important}
    .template_selected { border: 1px solid #205CDF }
    .template_card:hover .v-chip.purple,  .template_card:focus .v-chip.purple {
        background: #fff !important;
        color: #5C068C !important;
    }
    .template_filter {flex: 1; }
</style>